import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  standalone: true,
  name: 'eeDate',
})
export class EeDatePipe implements PipeTransform {

  transform(value: string|moment.Moment, format: string = 'DD/MM/YYYY'): string {
    moment.locale('fr');
    const date = value ? moment(value, format) : null;
    // If value is not set or date is after year 9999, return empty string
    if (!value || (date && date.year() >= 9999)) {
      return '';
    }
    return date.format('DD/MM/YYYY');
  }

}
